/**
 * Rewrites a legacy per-region S3 host to the AU (`ap-southeast-2`) bucket.
 *
 * Profile pictures are still stored in per-region S3 buckets, but are only
 * served from the AU bucket — so a stored URL pointing at any other region has
 * to be swapped at read time or the image 404s.
 *
 * TODO: migrate all profile pictures to the global S3 buckets and delete this
 * helper. That is not a frontend-only change: it needs a substantial DB
 * migration over user documents to repoint every stored profile-picture URL at
 * the new global locations. Until that lands, this read-time rewrite is the
 * only thing keeping cross-region avatars resolving.
 */
export const redirectToAPSE = (url: string | null | undefined): string | null => {
  if (!url) {
    return null;
  }

  return url.replace(
    /s3[.-](?:us-east-1|eu-west-2|ca-central-1|eu-central-1)/g,
    's3.ap-southeast-2'
  );
};
